import React, { useEffect, useState } from 'react';

import { Grid, Link, Typography } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { BehaviorSubject } from 'rxjs';

export default ({ newResources$ = new BehaviorSubject([]), onRefresh }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const subscription = newResources$.subscribe((resources) => setCount(resources.length));
    return () => subscription.unsubscribe();
  }, [newResources$]);

  const handleClick = (event) => {
    if (onRefresh) onRefresh();
    event.preventDefault();
  };

  if (!count) return null;

  return (
    <Grid container item xs={3} style={{ alignItems: 'center' }}>
      <Typography variant="subtitle1" style={{ color: 'red', fontStyle: 'italic' }}>
        {count} resources added
      </Typography>
      <Link href="" style={{ alignItems: 'center', display: 'flex', paddingLeft: 4 }} onClick={handleClick}>
        <RefreshIcon />
        Refresh now
      </Link>
    </Grid>
  );
};
